import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ImagenCliente, ImagenEmpleado } from "../../configuracion/apiUrls";
import { useContextUsuario } from '../../contexto/usuario/UsuarioContext';
import CerrarSesionButton from "../contenedores/CerrarSesion";
import NavItems from "./NavItems";
import RelojDigital from "./RelojDigital";
import { NegocioConfig } from "../../configuracion/Empresa";
import { cerrarSidebar, isSidebarOpen } from "./sidebarUtils";

const SideNav = () => {
  const { usuario } = useContextUsuario();
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState([]);

  useEffect(() => {
    const currentPath = location.pathname;
    const items = usuario.tipo === "Empleado" ? navFiltrado : navItemClientes;

    const activeMenuIndex = items.findIndex(item =>
      item.urls?.some(subItem => subItem.url === currentPath)
    );

    if (activeMenuIndex !== -1 && !expandedItems.includes(activeMenuIndex)) {
      setExpandedItems(prev => {
        if (!prev.includes(activeMenuIndex)) {
          return [...prev, activeMenuIndex];
        }
        return prev;
      });
    }
  }, [location.pathname, usuario.tipo]);


  // Cerrar la barra lateral al cambiar de ruta en resoluciones bajas
  useEffect(() => {
    if (window.innerWidth <= 1024 || document.body.classList.contains('sidebar-open')) {
      cerrarSidebar();
    }
  }, [location.pathname]);

  // Listener para cerrar al hacer clic o tocar fuera de la barra lateral
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!isSidebarOpen()) return;

      const isLowResolution = window.innerWidth <= 1024 || document.body.classList.contains('sidebar-open');
      if (!isLowResolution) return;

      const sidebar = document.querySelector('.main-sidebar');
      const toggleBtn = document.querySelector('[data-widget="pushmenu"]');

      if (sidebar && sidebar.contains(event.target)) return;
      if (toggleBtn && toggleBtn.contains(event.target)) return;

      cerrarSidebar();
    };

    document.addEventListener('click', handleClickOutside, true);
    document.addEventListener('touchstart', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      document.removeEventListener('touchstart', handleClickOutside, true);
    };
  }, []);

  const handleMenuToggle = (index) => {
    setExpandedItems((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );
  };

  const isMenuExpanded = (index) => expandedItems.includes(index);
  const normalizarRuta = (ruta = "") => ruta.replace(/\/+$/, "");

  const navItemEmpleados = [
    {
      nombre: "Pedidos",
      icono: "fas fa-box",
      url: "/app/admin/pedidos",
      urls: [
        { url: "/app/admin/pedidos/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/pedidos/buscar", permiso: "Buscar", nombre: "Buscar" },
        { url: "/app/admin/pedidos/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
      ]
    },
    {
      nombre: "Cotizaciones",
      icono: "fas fa-file-invoice",
      url: "/app/admin/cotizaciones",
      urls: [
        { url: "/app/admin/cotizaciones/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/cotizaciones/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
      ]
    },
    {
      nombre: "Ventas",
      icono: "fas fa-file-invoice-dollar",
      url: "/app/admin/ventas",
      urls: [
        { url: "/app/admin/ventas/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/ventas/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
        { url: "/app/admin/ventas/ver", permiso: "Ver", nombre: "Ver" },
        { url: "/app/admin/ventas/credito", permiso: "Credito", nombre: "Crédito" },
        { url: "/app/admin/ventas/analisis", permiso: "Analisis", nombre: "Análisis" },
      ]
    },
    {
      nombre: "Compras",
      icono: "fas fa-shopping-cart",
      url: "/app/admin/compras",
      urls: [
        { url: "/app/admin/compras/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/compras/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
        { url: "/app/admin/compras/credito", permiso: "Credito", nombre: "Crédito" }
      ]
    },
    {
      nombre: "Cajero",
      icono: "fas fa-cash-register",
      url: "/app/admin/cajeros",
      urls: [
        { url: "/app/admin/cajeros/apertura", permiso: "Apertura", nombre: "Apertura" },
        { url: "/app/admin/cajeros/buscarCierre", permiso: "BuscarCierre", nombre: "Buscar Cierre" },
        { url: "/app/admin/cajeros/buscarApertura", permiso: "BuscarApertura", nombre: "Buscar Apertura" },
        { url: "/app/admin/cajeros/ingresosEgresos", permiso: "IngresosEgresos", nombre: "Ingresos y Egresos" },
        { url: "/app/admin/cajeros/cierre", permiso: "Cierre", nombre: "Cierre" },
        { url: "/app/admin/cajeros/buscarpagos", permiso: "BuscarPagos", nombre: "Buscar Pagos" },
      ]
    },
    {
      nombre: "Productos",
      icono: "fas fa-box",
      url: "/app/admin/productos",
      urls: [
        { url: "/app/admin/productos/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/productos/buscar", permiso: "Buscar", nombre: "Buscar" },
        { url: "/app/admin/productos/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
        { url: "/app/admin/productos/tipos", permiso: "Tipos", nombre: "Tipos" },
      ]
    },
    {
      nombre: "Lotes",
      icono: "fas fa-layer-group",
      url: "/app/admin/lotes",
      urls: [
        { url: "/app/admin/lotes/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
        { url: "/app/admin/lotes/asignar", permiso: "Asignar", nombre: "Asignar" },
      ]
    },
    {
      nombre: "Inventarios",
      icono: "fas fa-warehouse",
      url: "/app/admin/inventarios",
      urls: [
        { url: "/app/admin/inventarios/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/inventarios/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
        { url: "/app/admin/inventarios/tipos", permiso: "Tipos", nombre: "Tipos" },
      ]
    },
    {
      nombre: "Promociones",
      icono: "fas fa-tags",
      url: "/app/admin/promociones",
      urls: [
        { url: "/app/admin/promociones/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/promociones/buscar", permiso: "Buscar", nombre: "Buscar" },
        { url: "/app/admin/promociones/editar", permiso: "Editar", nombre: "Editar" }
      ]
    },
    {
      nombre: "Proveedores",
      icono: "fas fa-truck",
      url: "/app/admin/proveedores",
      urls: [
        { url: "/app/admin/proveedores/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/proveedores/buscar", permiso: "Buscar", nombre: "Buscar" },
        { url: "/app/admin/proveedores/gestionar", permiso: "Gestionar", nombre: "Gestionar" }
      ]
    },
    {
      nombre: "Clientes",
      icono: "fas fa-user-tie",
      url: "/app/admin/clientes",
      urls: [
        /*{ url: "/app/admin/clientes/nuevo", permiso: "Nuevo", nombre: "Nuevo" },*/
        { url: "/app/admin/clientes/auto", permiso: "Auto", nombre: "Nuevo" },
        { url: "/app/admin/clientes/buscar", permiso: "Buscar", nombre: "Buscar" },
        { url: "/app/admin/clientes/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
      ]
    },
    {
      nombre: "Empleados",
      icono: "fas fa-users",
      url: "/app/admin/empleados",
      urls: [
        { url: "/app/admin/empleados/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/admin/empleados/buscar", permiso: "Buscar", nombre: "Buscar" },
        { url: "/app/admin/empleados/gestionar", permiso: "Gestionar", nombre: "Gestionar" },
        { url: "/app/admin/empleados/cargos", permiso: "Cargos", nombre: "Cargos" },
        { url: "/app/admin/empleados/accesos", permiso: "Accesos", nombre: "Accesos" },
      ]
    },
    {
      nombre: "Planillas",
      icono: "fas fa-money-check-alt",
      url: "/app/admin/planillas",
      urls: [
        { url: "/app/admin/planillas", permiso: "Ver", nombre: "Gestión Planillas" },
        { url: "/app/admin/planillas/generar", permiso: "Generar", nombre: "Generar Planilla" },
        { url: "/app/admin/planillas/configuracion", permiso: "Configuracion", nombre: "Configuración Salarial" },
        { url: "/app/admin/planillas/prestamos", permiso: "Prestamos", nombre: "Préstamos / Anticipos" },
      ]
    },
  ];

  const navItemClientes = [
    {
      nombre: "Pedidos",
      icono: "fas fa-shopping-cart",
      urls: [
        { url: "/app/clientes/pedidos/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/clientes/pedidos/editar", permiso: "Ver", nombre: "Ver" },
      ]
    },
    {
      nombre: "Cotizaciones",
      icono: "fas fa-file-invoice",
      urls: [
        { url: "/app/clientes/cotizaciones/nuevo", permiso: "Nuevo", nombre: "Nuevo" },
        { url: "/app/clientes/cotizaciones/editar", permiso: "Ver", nombre: "Ver" },
      ]
    }
  ];

  const accesosUsuario = Object.fromEntries(
    (usuario?.accesos || [])
      .filter(item => item?.ruta && item?.permisos)
      .map(item => {
        const ruta = normalizarRuta(item.ruta);
        const permisos = item.permisos.split(",").map(p => p.trim());
        return [ruta, permisos];
      })
  );

  const navFiltrado = navItemEmpleados
    .map(item => {
      const rutaItem = normalizarRuta(item.url || "");
      if (item.url === "/app/admin/planillas") {
        return item;
      }
      const permisos = accesosUsuario[rutaItem];
      if (!permisos) return null;

      const urlsFiltradas = item.urls?.filter(sub => permisos.includes(sub.permiso)) || [];
      return urlsFiltradas.length > 0 ? { ...item, urls: urlsFiltradas } : null;
    })
    .filter(Boolean);

  const imagen = usuario?.datoPersonales?.imagen
    ? usuario.tipo === "Cliente"
      ? ImagenCliente + usuario.datoPersonales.imagen
      : ImagenEmpleado + usuario.datoPersonales.imagen
    : ImagenCliente + "clientes.jpeg";

  const nombreUsuario =
    usuario?.login != null
      ? `${usuario.datoPersonales.primerNombre} ${usuario.datoPersonales.primerApellido}`
      : "Usuario";

  const rutaPerfil =
    usuario?.tipo === "Empleado"
      ? "/app/admin/perfil"
      : usuario?.tipo === "Cliente"
        ? "/app/clientes/perfil"
        : "#";

  const primerGrupoAccesible = navFiltrado[0];
  const primeraRutaBase = primerGrupoAccesible?.url || "/app/admin/";

  const rutaAnalisisNormalizada = normalizarRuta("/app/admin/analisis/");
  const tienePermisoAnalisis = !!accesosUsuario[rutaAnalisisNormalizada];

  return (
    <aside className="main-sidebar main-sidebar-custom sidebar-dark-primary d-flex flex-column">
      <div className="brand-link d-flex align-items-center px-3">
        <Link to={usuario.tipo === "Cliente" ? "/app/clientes/" : "/app/admin/empleados/"} className="d-flex align-items-center text-decoration-none" style={{ minWidth: 0 }}>
          <img
            src={NegocioConfig.logo}
            alt="Logo SIGVEM"
            className="brand-image img-circle elevation-3"
            style={{ opacity: ".8", width: "35px", height: "35px" }}
          />
          <span className="brand-text font-weight-normal h3 mx-2 my-0 text-white text-truncate">{NegocioConfig.sistema}</span>
        </Link>
      </div>
      <div className="sidebar flex-grow-1" style={{ overflowY: 'auto' }}>
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img
              className="img-circle elevation-2"
              src={imagen}
              alt="Imagen de perfil de usuario"
              crossOrigin="anonymous"
              style={{
                width: "35px",
                height: "35px",
                objectFit: "cover",
                objectPosition: "center",
              }}
            />
          </div>
          <div className="info">
            <Link to={rutaPerfil} className="d-block">
              {nombreUsuario}
            </Link>
          </div>
        </div>
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column nav-legacy" data-widget="treeview" role="menu" data-accordion="false">
            <li className="nav-header">Menu Principal</li>
            <li className="nav-item">
              <Link to={usuario.tipo === "Cliente" ? "/app/clientes/" : primeraRutaBase} className="nav-link" onClick={() => { if (window.innerWidth <= 1024 || document.body.classList.contains("sidebar-open")) cerrarSidebar(); }}>
                <i className="nav-icon fas fa-tachometer-alt" />
                <p>Inicio</p>
              </Link>
            </li>
            {tienePermisoAnalisis && (
              <li className="nav-item">
                <Link to="/app/admin/analisis/" className="nav-link" onClick={() => { if (window.innerWidth <= 1024 || document.body.classList.contains("sidebar-open")) cerrarSidebar(); }}>
                  <i className="nav-icon fas fa-chart-bar" />
                  <p>Análisis</p>
                </Link>
              </li>
            )}
            <NavItems
              items={usuario.tipo === "Empleado" ? navFiltrado : navItemClientes}
              handleMenuToggle={handleMenuToggle}
              isMenuExpanded={isMenuExpanded}
            />
            <li className="nav-item">
              <RelojDigital />
            </li>
          </ul>
        </nav>
      </div>
      <div className="sidebar-custom d-flex justify-content-between align-items-center p-3">
        <CerrarSesionButton />
      </div>
    </aside>
  );
};

export default SideNav;
